import Vue from 'vue'
import Vuex from 'vuex'
import core from '@/store/core'
import card from '@/store/card'
Vue.use(Vuex)

const mstore = new Vuex.Store({
  modules: {
    core: core,
    card: card
  }
})
export default mstore